import { render } from "./cmf-textarea.vue?vue&type=template&id=25539c6c&scoped=true"
import script from "./cmf-textarea.vue?vue&type=script&lang=js"
export * from "./cmf-textarea.vue?vue&type=script&lang=js"

import "./cmf-textarea.vue?vue&type=style&index=0&id=25539c6c&lang=sass"
import "./cmf-textarea.vue?vue&type=style&index=1&id=25539c6c&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25539c6c"]])

export default __exports__